import script from "./PbxDeviceClaimModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxDeviceClaimModal.vue?vue&type=script&setup=true&lang=js"

import "./PbxDeviceClaimModal.vue?vue&type=style&index=0&id=54415b34&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54415b34"]])

export default __exports__